// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ingest__tabs>.v-tabs-bar{border-right:1px solid #e0e0e0;box-shadow:5px 0 11px -12px rgba(0,0,0,.71);z-index:1}.ingest__tabs>.v-tabs-items{max-height:100vh;overflow-y:hidden}.ingest__tabs .v-tab{text-transform:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
